import { Node } from '@components/ArtBoard/Node'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '../../../../types'

const NodeOverlay: React.FC = () => {
  const id = useSelector<AppState, string | null>(
    ({ artboard }) => artboard.dragAndDrop.dragged.id
  )
  const ids = useSelector<AppState, string[]>(
    ({ artboard }) => artboard.dragAndDrop.dragged.ids
  )

  if (!id) {
    return null
  }

  if ((ids.length === 0 && id) || ids.length === 1) {
    const node = useSelector(
      migrationProjectSelector.getProjectNodeById(ids.length ? ids[0] : id)
    )

    return (
      <Node
        {...node}
        // @ts-expect-error
        // @TODO move all props inside of component
        // node should get only id and isOverlay
        parentId={node?.parentId}
        variant={node?.variant}
        isDraggable={false}
        isChild={false}
        arrowMode={false}
        isOverlay
      />
    )
  }

  const node = useSelector(migrationProjectSelector.getProjectNodeById(id))

  return (
    <Node
      {...node}
      // @ts-expect-error
      // @TODO move all props inside of component
      // node should get only id and isOverlay
      parentId={node?.parentId}
      variant="stack"
      oldVariant={node?.variant}
      isDraggable={false}
      isChild={false}
      arrowMode={false}
      isOverlay
    />
  )
}

export default NodeOverlay
